<template>
    <yams-template :withoutHeader="true">
        <template #content>
            <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                    <div class="mr-5">
                        <h4 class="text-primary font-weight-bold">Gestion des adresses</h4>
                    </div>
                    <div class="mr-4">
                        <NavOperations></NavOperations>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <h3 class="mb-2">Mes adresses</h3>
                    <div v-if="adresses.length" class="card mb-3" style="height: 30vh; overflow-y: auto;">
                        <div class="card-body ">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" v-for="(item, index) in adresses" :key="index"
                                    style="cursor: pointer;" @click="centerMapOnAdresse(item)">
                                    {{ item.libelle }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="card card-body">
                        <p v-if="newAddressSelected == null" class="text-primary text-center">
                            <i class="fas fa-info-circle mr-1"></i>
                            Veuillez suivre ces étapes pour ajouter une adresse:
                        </p>
                        <ol v-if="newAddressSelected == null">
                            <li>Cliquez sur la carte pour placer un marqueur</li>
                            <li>Remplissez les informations dans le formulaire</li>
                            <li>Cliquez sur "Enregistrer"</li>
                        </ol>
                        <form v-else @submit.prevent="validateAndSaveAddress">
                            <div class="form-group">
                                <label>Selectionner la ville <span class="text-danger">*</span></label>
                                <select class="form-control" v-model="form.ville_id"
                                    :class="{ 'is-invalid': formErrors.ville_id }">
                                    <option value="">Sélectionnez une ville</option>
                                    <option v-for="(item, index) in villes" :key="index" :value="item.id">{{
                                        item.libelle }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="formErrors.ville_id">
                                    Veuillez sélectionner une ville
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Libellé <span class="text-danger">*</span></label>
                                <input class="form-control" v-model="form.libelle" type="text"
                                    placeholder="Entrez un libellé" :class="{ 'is-invalid': formErrors.libelle }" />
                                <div class="invalid-feedback" v-if="formErrors.libelle">
                                    Le libellé ne peut pas être vide
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Position <span class="text-danger">*</span></label>
                                <div class="alert alert-success">
                                    <i class="fas fa-map-marker-alt mr-1"></i> Position sélectionnée sur la carte
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary btn-block" @click="validateAndSaveAddress"
                                :disabled="isLoading">
                                <i class="fas fa-save mr-1"></i> Enregistrer
                                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status"
                                    aria-hidden="true"></span>
                            </button>
                        </form>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <div>
                                <h5 class="mb-0">{{ mapTitle }}</h5>
                                <p class="text-muted mb-0" v-if="!selectedAdresse">
                                    <i class="fas fa-mouse-pointer mr-1"></i>
                                    Cliquez sur la carte pour ajouter une nouvelle adresse
                                </p>
                                <p class="text-muted mb-0" v-else>
                                    <i class="fas fa-map-marker-alt mr-1"></i>
                                    {{ selectedAdresse.libelle }} - {{ selectedAdresse.ville }}
                                </p>
                            </div>
                            <button class="btn btn-outline-secondary" @click="resetMap" title="Réinitialiser la carte">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-rotate-ccw-icon lucide-rotate-ccw">
                                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                    <path d="M3 3v5h5" />
                                </svg>
                            </button>
                        </div>
                        <div class="card-body p-0">
                            <div id="mapContainer" style="height: 600px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </yams-template>
</template>

<script>
import $ from "jquery";
import { defineComponent } from 'vue';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import NavOperations from '../NavOperations.vue';

export default defineComponent({
    name: 'IndexAdresse',
    components: { NavOperations },
    data() {
        return {
            resIsLoading: false,
            isLoading: false,
            table: 'adresses',
            baseUrl: this.$store.state.api_yams_livraisons,
            villes: [],
            adresses: [],
            form: {
                libelle: '',
                ville_id: null,
                ville_nom: '', // Ajout du nom de la ville
                lat: null,
                lng: null,
                utilisateur_id: this.$store.state.user ? this.$store.state.user.id : null,
                utilisateur_nom: this.$store.state.user ? this.$store.state.user.name : null // Ajout du nom d'utilisateur
            },
            formErrors: {
                libelle: false,
                ville_id: false,
                lat: false,
                lng: false,
                utilisateur_id: false
            },
            newAddressSelected: null,
            map: null,
            markers: [],
            currentMarker: null,
            selectedMarker: null,
            selectedAdresse: null, // Pour stocker l'adresse sélectionnée
            libreville: {
                lat: 0.4162,
                lng: 9.4673
            }
        }
    },
    computed: {
        mapTitle() {
            return this.selectedAdresse
                ? `Adresse: ${this.selectedAdresse.libelle} (${this.selectedAdresse.ville})`
                : 'Carte de Libreville';
        }
    },
    mounted() {
        this.getVilles();
        this.getAdresses();
        this.$nextTick(() => {
            this.initMap();
        });
    },
    methods: {
        initMap() {
            // Création de l'icône par défaut pour les marqueurs
            const defaultIcon = L.icon({
                iconUrl: require('@/assets/marker-bleu.png'),
                iconSize: [30, 30],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34]
            });

            // Création de l'icône pour le nouveau marqueur
            const newMarkerIcon = L.icon({
                iconUrl: require('@/assets/marker-noir.png'),
                iconSize: [30, 30],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34]
            });

            // Initialisation de la carte avec zoom sur Libreville
            this.map = L.map('mapContainer').setView([this.libreville.lat, this.libreville.lng], 13);

            // Ajout de la couche de tuiles OpenStreetMap
            L.tileLayer('https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', {
                maxZoom: 20,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            }).addTo(this.map);

            // Ajouter les adresses existantes sur la carte
            this.adresses.forEach(adresse => {
                if (adresse.lat && adresse.lng) {
                    const marker = L.marker([adresse.lat, adresse.lng], { icon: defaultIcon })
                        .addTo(this.map)
                        .bindPopup(adresse.libelle);
                    this.markers.push(marker);
                }
            });

            // Ajout d'un gestionnaire d'événement pour les clics sur la carte
            this.map.on('click', (event) => {
                // Supprimer le marqueur temporaire s'il existe déjà
                if (this.currentMarker) {
                    this.map.removeLayer(this.currentMarker);
                }

                // Ajouter un nouveau marqueur à l'endroit où l'utilisateur a cliqué
                const { lat, lng } = event.latlng;
                this.currentMarker = L.marker([lat, lng], { icon: newMarkerIcon }).addTo(this.map);

                // Mettre à jour les coordonnées dans le formulaire
                this.form.latitude = lat;
                this.form.longitude = lng;
                this.newAddressSelected = { lat, lng };
            });
        },
        getAdresses() {
            this.resIsLoading = true
            this.axios.get('/api/adresses').then((response) => {
                this.adresses = response.data.data
                this.resIsLoading = false
                // Si la carte est déjà initialisée, mettre à jour les marqueurs
                if (this.map) {
                    this.updateMarkers();
                }
            }).catch(() => {
                this.resIsLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        getVilles() {
            this.resIsLoading = true
            this.axios.get('/api/villes').then((response) => {
                this.villes = response.data.data
                this.resIsLoading = false
            }).catch(() => {
                this.resIsLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        centerMapOnAdresse(adresse) {
            // Zoom sur l'adresse sélectionnée
            if (adresse.lat && adresse.lng) {
                this.map.setView([adresse.lat, adresse.lng], 16);

                // Supprimer le marqueur précédent s'il existe
                if (this.selectedMarker) {
                    this.map.removeLayer(this.selectedMarker);
                }

                // Créer l'icône bleue pour le marqueur sélectionné
                const defaultIcon = L.icon({
                    iconUrl: require('@/assets/marker-bleu.png'),
                    iconSize: [30, 30],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34]
                });

                // Ajouter un nouveau marqueur pour l'adresse sélectionnée
                this.selectedMarker = L.marker([adresse.lat, adresse.lng], { icon: defaultIcon })
                    .addTo(this.map)
                    .bindPopup(adresse.libelle)
                    .openPopup();

                // Mettre à jour l'adresse sélectionnée pour le titre dynamique
                this.selectedAdresse = adresse;
            }
        },
        updateMarkers() {
            // Supprimer tous les marqueurs existants
            this.markers.forEach(marker => this.map.removeLayer(marker));
            this.markers = [];

            // Ajouter les marqueurs mis à jour
            const defaultIcon = L.icon({
                iconUrl: require('@/assets/marker-bleu.png'),
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34]
            });

            this.adresses.forEach(adresse => {
                if (adresse.latitude && adresse.longitude) {
                    const marker = L.marker([adresse.latitude, adresse.longitude], { icon: defaultIcon })
                        .addTo(this.map)
                        .bindPopup(adresse.libelle);
                    this.markers.push(marker);
                }
            });
        },
        validateAndSaveAddress() {
            // Remise à zéro des erreurs
            this.formErrors = {
                libelle: false,
                ville_id: false,
                lat: false,
                lng: false,
                utilisateur_id: false
            };

            // Validation des champs
            if (!this.form.libelle) this.formErrors.libelle = true;
            if (!this.form.ville_id) this.formErrors.ville_id = true;

            // S'assurer que les coordonnées sont correctement assignées
            if (this.newAddressSelected) {
                // Mapper les coordonnées correctement
                this.form.lat = this.newAddressSelected.lat;
                this.form.lng = this.newAddressSelected.lng;
            } else {
                this.formErrors.lat = true;
                this.formErrors.lng = true;
            }

            // Vérifier que l'utilisateur est défini
            if (!this.form.utilisateur_id) {
                // Récupérer l'ID utilisateur du store s'il existe
                const user = this.$store.state.user;

                if (user) {
                    this.form.utilisateur_id = user.id;
                    this.form.utilisateur_nom = user.name;
                } else {
                    this.formErrors.utilisateur_id = true;
                }
            }

            // Obtenir le nom de la ville sélectionnée
            if (this.form.ville_id) {
                const villeSelectionnee = this.villes.find(v => v.id === this.form.ville_id);
                if (villeSelectionnee) {
                    this.form.ville_nom = villeSelectionnee.libelle;
                }
            }

            // Vérifier s'il y a des erreurs
            const hasErrors = Object.values(this.formErrors).some(error => error);

            if (hasErrors) {
                const errorMessages = [];
                if (this.formErrors.libelle) errorMessages.push("Le libellé est obligatoire");
                if (this.formErrors.ville_id) errorMessages.push("La ville est obligatoire");
                if (this.formErrors.lat || this.formErrors.lng) errorMessages.push("Veuillez sélectionner une position sur la carte");
                if (this.formErrors.utilisateur_id) errorMessages.push("L'utilisateur n'est pas défini");

                this.$toast.add({
                    severity: 'warn',
                    summary: 'Validation',
                    detail: 'Veuillez corriger les erreurs suivantes : ' + errorMessages.join(', '),
                    life: 5000
                });
                return;
            }

            this.saveAddress();
        },

        saveAddress() {
            this.isLoading = true;

            // Utiliser les noms au lieu des IDs pour correspondre à la structure de l'API
            const addressData = {
                libelle: this.form.libelle,
                ville: this.form.ville_nom, // Envoyer le nom de la ville
                lat: this.form.lat,
                lng: this.form.lng,
                utilisateur: this.form.utilisateur_nom // Envoyer le nom d'utilisateur
            };

            console.log('Payload envoyé:', addressData);

            this.axios.post('/api/adresses', addressData)
                .then((response) => {
                    this.isLoading = false;
                    if (response.data.success === true) {
                        this.resetForm();
                        this.getAdresses();
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: response.data.message || 'Adresse ajoutée avec succès',
                            life: 3000
                        });
                    }
                    else {
                        // Affichage des erreurs retournées par l'API de manière plus détaillée
                        if (response.data.errors && Array.isArray(response.data.errors)) {
                            // Mettre à jour les erreurs de formulaire en fonction des erreurs retournées
                            response.data.errors.forEach(error => {
                                if (error.includes('libelle')) this.formErrors.libelle = true;
                                if (error.includes('ville')) this.formErrors.ville_id = true;
                                if (error.includes('lat')) this.formErrors.lat = true;
                                if (error.includes('lng')) this.formErrors.lng = true;
                                if (error.includes('utilisateur')) this.formErrors.utilisateur_id = true;
                            });

                            this.$toast.add({
                                severity: 'error',
                                summary: 'Erreur de validation',
                                detail: response.data.errors.join('<br>'),
                                life: 5000
                            });
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Erreur',
                                detail: 'Une erreur s\'est produite lors de l\'enregistrement de l\'adresse',
                                life: 3000
                            });
                        }
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.error('Erreur lors de l\'ajout d\'adresse:', error);

                    let errorMessage = 'Une erreur s\'est produite lors de l\'enregistrement de l\'adresse';

                    if (error.response && error.response.data && error.response.data.errors) {
                        if (Array.isArray(error.response.data.errors)) {
                            errorMessage = error.response.data.errors.join('<br>');
                        } else {
                            errorMessage = error.response.data.message || errorMessage;
                        }
                    }

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: errorMessage,
                        life: 5000
                    });
                });
        },

        resetMap() {
            // Réinitialiser la vue à Libreville
            this.map.setView([this.libreville.lat, this.libreville.lng], 13);

            // Supprimer le marqueur de sélection s'il existe
            if (this.selectedMarker) {
                this.map.removeLayer(this.selectedMarker);
                this.selectedMarker = null;
            }

            // Supprimer le marqueur temporaire s'il existe
            if (this.currentMarker) {
                this.map.removeLayer(this.currentMarker);
                this.currentMarker = null;
            }

            // Réinitialiser l'adresse sélectionnée
            this.selectedAdresse = null;
            this.newAddressSelected = null;

            // Réinitialiser le formulaire
            this.resetForm();
        },

        resetForm() {
            this.form = {
                libelle: '',
                ville_id: '',
                ville_nom: '',
                lat: null,
                lng: null,
                utilisateur_id: this.$store.state.user ? this.$store.state.user.id : null,
                utilisateur_nom: this.$store.state.user ? this.$store.state.user.name : null
            };
            this.newAddressSelected = null;

            // Supprimer le marqueur temporaire s'il existe
            if (this.currentMarker) {
                this.map.removeLayer(this.currentMarker);
                this.currentMarker = null;
            }
        }
    }
})
</script>

<style scoped>
.list-group-item:hover,
.active {
    background-color: antiquewhite;
    color: blueviolet;
}

/* Styles supplémentaires pour la carte */
#mapContainer {
    width: 100%;
    z-index: 1;
    /* Pour s'assurer que la carte s'affiche correctement */
}

/* Fix pour les icônes Leaflet */
.leaflet-default-icon-path {
    background-image: url("leaflet/dist/images/marker-icon.png");
}
</style>